<template>
  <v-container fluid py-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid pt-0>
          <v-row align="center">
            <div>
              <h1 class="headline">Export Logs</h1>
            </div>
            <v-col class="py-0">
              <list-filters
                :filters="filters"
                label="Find Export Log"
                ref-name="exportLogsListFilters"
                @searchParamsChanged="searchParamsChanged"
                :expansionPanel="false"
                :minColumns="4"
              ></list-filters>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="$apollo.loading"
      :search="search"
      item-key="id"
      class="elevation-1"
      v-bind="pagingOptions"
      fixed-header
      hide-default-footer
      @update:options="onListOptionsUpdate"
    >
      <template #[`item.results`]="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              dark
              color="indigo"
              @click="onRequestFile(item)"
              v-on="on"
            >
              <v-icon small>file_download</v-icon>
            </v-btn>
          </template>
          Download File
        </v-tooltip>
      </template>
      <template #[`item.criteria`]="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-icon small v-on="on">info</v-icon>
          </template>
          <export-logs-item-filters v-model="item.criteria" />
        </v-tooltip>
      </template>
    </v-data-table>

    <get-more-results
      :first="first"
      @limitChange="onLimitChange"
      :items="exportLogs"
      :totalItems="totalItems"
      :loading="$apollo.loading"
      :loadMoreEnabled="loadMoreEnabled"
      @loadMore="loadMore('exportLogs')"
    ></get-more-results>
    <v-row v-if="debug">
      <v-col cols="12">
        <pre>
          {{ searchParams }}
        </pre>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { ListMixin } from "../../../../mixins/ListMixin";
import { ALL_EXPORT_LOGS_SEARCH_QUERY } from "../../../../constants/graphql";
import GetMoreResults from "../../shared/GetMoreResults";
import { removeGQLTypename } from "../../../../helpers";
import gql from "graphql-tag";
import ExportLogsItemFilters from "./ExportLogsItemFilters.vue";
import ListFilters from "../../shared/list-filters/ListFilters.vue";
import exportLogsFilters from "./export-logs-filters";
const GET_DOWNLOAD_URL = gql`
  mutation requestDownloadLogUrl($id: ID!) {
    requestDownloadLogUrl(id: $id) {
      success
      message
    }
  }
`;
export default {
  name: "ExportLogsList",
  mixins: [ListMixin],
  components: {
    GetMoreResults,
    ExportLogsItemFilters,
    ListFilters,
  },

  data() {
    return {
      debug: false,
      exportLogs: {},
      headers: [
        {
          text: "Exported by",
          value: "userName",
          name: "userName",
        },
        {
          text: "Exported",
          value: "name",
          name: "name",
        },

        {
          text: "Exported On",
          value: "createdAt",
          name: "createdAt",
        },
        {
          text: "Time",
          value: "createdAtTime",
          name: "createdAtTime",
        },
        {
          text: "Filters",
          value: "criteria",
          name: "criteria",
        },
        {
          text: "No of  records",
          value: "recordsCount",
          name: "recordsCount",
        },
        {
          text: "File",
          value: "results",
          name: "results",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.exportLogs && this.exportLogs.edges
        ? this.exportLogs.edges.map(removeGQLTypename)
        : [];
    },
    filters() {
      return exportLogsFilters.map((f) => {
        f.props.outlined = this.$store.getters.localSettings("outlinedInputs");
        return f;
      });
    },
  },

  methods: {
    onRequestFile(item) {
      //console.log("request file", item);
      this.$apollo
        .mutate({
          mutation: GET_DOWNLOAD_URL,
          variables: { id: item.id },
        })
        .then((result) =>
          window.open(result.data.requestDownloadLogUrl.message)
        )
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    exportLogs: {
      query: ALL_EXPORT_LOGS_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          sort: this.sort,
          first: this.first,
          filter: this.searchParams,
        };
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.totalItems = data.exportLogs.totalCount;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/admin/logs/ExportLogsList.vue